import { ICategory } from 'categories/types';
import { IPartDetails, IPartManufacturer, ISavePartPayload } from 'parts/types';

import { IEditPartSetupFormValues } from './types';

const getPartLeafCategory = (part: IPartDetails): ICategory | null => {
  const trail = part.categories;

  if (!trail || trail.length === 0) {
    return null;
  }

  const leaf = trail[trail.length - 1];

  if (!leaf?.id || !leaf?.name) {
    return null;
  }

  return { id: leaf.id, name: leaf.name } as ICategory;
};

export const getDefaultValues = (part?: IPartDetails | null): IEditPartSetupFormValues => {
  if (!part) {
    return { category: null, description: '', orderingNumber: '', engineeringNumber: '' };
  }

  return {
    category: getPartLeafCategory(part),
    description: part.descriptionLong ?? '',
    orderingNumber: part.orderingNumber ?? '',
    engineeringNumber: part.engineeringNumber ?? '',
  };
};

export const buildSavePayload = (
  part: IPartDetails,
  manufacturer: IPartManufacturer | null | undefined,
  formValues: IEditPartSetupFormValues
): ISavePartPayload | null => {
  const manufacturerId = manufacturer?.id;
  const manufacturerName = manufacturer?.name;
  const categoryId = formValues.category?.id;

  if (manufacturerId == null || manufacturerName == null || categoryId == null) {
    return null;
  }

  // BE doesn't yet return ordering/engineering on get-details; omit when the source value
  // is undefined so we don't overwrite stored values during the transition window.
  // Once the field is loaded (even as ''), we send whatever the user has.
  return {
    number: part.number,
    manufacturerId,
    manufacturerName,
    categoryId,
    descriptionLong: formValues.description ?? '',
    ...(part.orderingNumber !== undefined && {
      orderingNumber: formValues.orderingNumber ?? '',
    }),
    ...(part.engineeringNumber !== undefined && {
      engineeringNumber: formValues.engineeringNumber ?? '',
    }),
  };
};
